import { Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { SupersetDashboardListDTO } from "../../../../datasources/api-client/data-contracts";
import { ThemeColors } from "../../../../theme/themeValues";

export const getRows = (data: SupersetDashboardListDTO, t: TFunction) => {
    if (!data) return [];

    return data.items.map((item: { embeddingId: string; name: string; rls?: string }) => {
        return {
            id: item.embeddingId,
            name: item.name,
        };
    });
}

export const colsData = (t: TFunction): GridColDef[] => [
    {
        field: "name",
        headerName: "name",
        flex: 1,
        sortable: true,
        renderCell: (params) => (
            <Stack height="100%" alignItems="start" justifyContent="center">
                <Typography variant="body2">{params.value}</Typography>
            </Stack>
        ),
    },
];

export const getColumns = (dataCol: GridColDef[], t: TFunction) =>
    dataCol.map((col, index) => {
        const label = col.headerName ? t(`${col.headerName}`) : "";
        return {
            ...col,
            headerName: label,
            renderHeader: () =>
                label && (
                    <Stack direction="column" width="100%">
                        <Stack
                            justifyContent={index === 5 || index === 6 ? "right" : "start"}
                            alignContent="start"
                            flexDirection="row"
                            alignItems="baseline"
                        >
                            <Typography fontWeight={700} sx={{ color: ThemeColors.LightContrastText }} variant="body2">
                                {label}
                            </Typography>
                        </Stack>
                    </Stack>
                ),
        };
    });
